module.exports = __webpack_public_path__ + "static/img/icon_filtering.f5168381.svg";